import React from 'react'

interface SleepSelectOptionProps {
  children: React.ReactNode
  selected: boolean
  onClick?: () => void
}

const SleepSelectOption: React.FC<SleepSelectOptionProps> = ({
  children,
  selected,
  onClick
}) => {
  return (
    <div
      className={`flex flex-col ${
        selected ? `bg-lightBlue` : `bg-white border-2 border-lightgray`
      } rounded-md p-4 cursor-pointer`}
      onClick={onClick}
      data-testid="snl-sleep-select-option"
    >
      {children}
    </div>
  )
}

export default SleepSelectOption